import { memo } from 'react';
import cn from 'bem-cn';

import { Stack } from '../../UI';

import { SlidesDotsProps } from './SlidesDots.types';
import './SlidesDots.scss';

const b = cn('slides-dots');

export const SlidesDots = memo((props: SlidesDotsProps) => {
    const { count, activeIndex, className } = props;

    return (
        <Stack className={b.mix(className)} direction="row">
            {Array.from({ length: count }).map((_, index) => (
                <span key={index} className={b('dot', { active: index === activeIndex })} />
            ))}
        </Stack>
    );
});

SlidesDots.displayName = 'SlidesDots';
